import { getCookie, setCookie, deleteCookie } from '@/platform/cookies/cookieStorage';
import { sharedCookieDomainForHost } from '@/platform/cookies/sharedCookieDomain';

/** Apex /setup/ reads this so notify UI can show the create-login email without Firebase SDK. */
export const CREATE_OWNER_EMAIL_COOKIE = 'communio_create_email';

const MAX_AGE_SECONDS = 60 * 60 * 24 * 14; // setup can take a while

export function persistCreateOwnerEmail(email: string): void {
  const normalized = email.trim().toLowerCase();
  if (!normalized.includes('@') || typeof window === 'undefined') return;
  const domain = sharedCookieDomainForHost(window.location.hostname);
  setCookie(CREATE_OWNER_EMAIL_COOKIE, normalized, {
    maxAgeSeconds: MAX_AGE_SECONDS,
    ...(domain ? { domain } : {}),
  });
}

export function readCreateOwnerEmail(): string | null {
  const v = (getCookie(CREATE_OWNER_EMAIL_COOKIE) || '').trim().toLowerCase();
  return v.includes('@') ? v : null;
}

export function clearCreateOwnerEmail(): void {
  if (typeof window === 'undefined') return;
  deleteCookie(CREATE_OWNER_EMAIL_COOKIE);
  const domain = sharedCookieDomainForHost(window.location.hostname);
  if (domain) deleteCookie(CREATE_OWNER_EMAIL_COOKIE, domain);
}
